import HIGHLIGHT_3_IMAGE from '../../../assets/images/club/stories/stories-highlights-3.webp';
import HIGHLIGHT_PREVIEW_IMAGE from '../../../assets/images/club/stories/stories-highlights-preview.webp';
import LIVIA_1_IMAGE from '../../../assets/images/club/stories/stories-levia-1.webp';
import LIVIA_2_IMAGE from '../../../assets/images/club/stories/stories-levia-2.webp';
import LEVIA_PREVIEW_IMAGE from '../../../assets/images/club/stories/stories-levia-preview.webp';
import SWITCH_LEVEL_STORE_IMAGE from '../../../assets/images/club/stories/stories-store.webp';
import SWITCH_11_SLIDE_1_IMAGE from '../../../assets/images/club/stories/switch-level1/switch11/slide-1.webp';
import SWITCH_11_SLIDE_2_5_IMAGE from '../../../assets/images/club/stories/switch-level1/switch11/slide-2-5.webp';
import SWITCH_11_SLIDE_2_LOW_IMAGE from '../../../assets/images/club/stories/switch-level1/switch11/slide-2-low.webp';
import SWITCH_11_SLIDE_2_IMAGE from '../../../assets/images/club/stories/switch-level1/switch11/slide-2-midhigh.webp';
import SWITCH_11_SLIDE_3_IMAGE from '../../../assets/images/club/stories/switch-level1/switch11/slide-3.webp';
import SWITCH_12_SLIDE_4_1_IMAGE from '../../../assets/images/club/stories/switch-level1/switch12/PROTECTED-slide-4-1.webp';
import SWITCH_12_SLIDE_1_IMAGE from '../../../assets/images/club/stories/switch-level1/switch12/slide-1.webp';
import SWITCH_12_SLIDE_2_IMAGE from '../../../assets/images/club/stories/switch-level1/switch12/slide-2.webp';
import SWITCH_12_SLIDE_2_1_SOCIAL_IMAGE from '../../../assets/images/club/stories/switch-level1/switch12/slide-2-1-social.webp';
import SWITCH_12_SLIDE_2_1_TASTE_IMAGE from '../../../assets/images/club/stories/switch-level1/switch12/slide-2-1-taste.webp';
import SWITCH_12_SLIDE_2_2_SOCIAL_IMAGE from '../../../assets/images/club/stories/switch-level1/switch12/slide-2-2-social.webp';
import SWITCH_12_SLIDE_2_3_SOCIAL_IMAGE from '../../../assets/images/club/stories/switch-level1/switch12/slide-2-3-social.webp';
import SWITCH_12_SLIDE_3_IMAGE from '../../../assets/images/club/stories/switch-level1/switch12/slide-3.webp';
import SWITCH_12_SLIDE_4_CC_IMAGE from '../../../assets/images/club/stories/switch-level1/switch12/slide-4-cc.webp';
import SWITCH_12_SLIDE_4_EVAPE_IMAGE from '../../../assets/images/club/stories/switch-level1/switch12/slide-4-evape.webp';
import SWITCH_12_SLIDE_4_POLYCOMP_IMAGE from '../../../assets/images/club/stories/switch-level1/switch12/slide-4-polycomp.webp';
import SWITCH_13_SLIDE_1_COMP_IMAGE from '../../../assets/images/club/stories/switch-level1/switch13/slide-1-comp.webp';
import SWITCH_13_SLIDE_1_EVAPE_IMAGE from '../../../assets/images/club/stories/switch-level1/switch13/slide-1-evape.webp';
import SWITCH_13_SLIDE_3_IMAGE from '../../../assets/images/club/stories/switch-level1/switch13/slide-3.webp';
import SWITCH_13_SLIDE_4_IMAGE from '../../../assets/images/club/stories/switch-level1/switch13/slide-4.webp';
import SWITCH_14_SLIDE_1_IMAGE from '../../../assets/images/club/stories/switch-level1/switch14/slide-1.webp';
import SWITCH_14_SLIDE_2_IMAGE from '../../../assets/images/club/stories/switch-level1/switch14/slide-2.webp';
import SWITCH_14_SLIDE_2_1_IMAGE from '../../../assets/images/club/stories/switch-level1/switch14/slide-2-1.webp';
import SWITCH_14_SLIDE_3_IMAGE from '../../../assets/images/club/stories/switch-level1/switch14/slide-3.webp';
import SWITCH_14_SLIDE_4_1_SOCIAL_IMAGE from '../../../assets/images/club/stories/switch-level1/switch14/slide-4-1-social.webp';
import SWITCH_14_SLIDE_4_1_TASTE_IMAGE from '../../../assets/images/club/stories/switch-level1/switch14/slide-4-1-taste.webp';
import SWITCH_14_SLIDE_4_2_SOCIAL_IMAGE from '../../../assets/images/club/stories/switch-level1/switch14/slide-4-2-social.webp';
import SWITCH_14_SLIDE_4_HEALTH_IMAGE from '../../../assets/images/club/stories/switch-level1/switch14/slide-4-health.webp';
import SWITCH_14_SLIDE_4_SOCIAL_IMAGE from '../../../assets/images/club/stories/switch-level1/switch14/slide-4-social.webp';
import SWITCH_14_SLIDE_4_TASTE_IMAGE from '../../../assets/images/club/stories/switch-level1/switch14/slide-4-taste.webp';
import SWITCH_15_SLIDE_1_IMAGE from '../../../assets/images/club/stories/switch-level1/switch15/slide-1.webp';
import SWITCH_15_SLIDE_2_1_CC_IMAGE from '../../../assets/images/club/stories/switch-level1/switch15/slide-2-1-cc.webp';
import SWITCH_15_SLIDE_2_CC_IMAGE from '../../../assets/images/club/stories/switch-level1/switch15/slide-2-cc.webp';
import SWITCH_15_SLIDE_3_1_CC_IMAGE from '../../../assets/images/club/stories/switch-level1/switch15/slide-3-1-cc.webp';
import SWITCH_15_SLIDE_3_1_EVAPE_IMAGE from '../../../assets/images/club/stories/switch-level1/switch15/slide-3-1-evape.webp';
import SWITCH_15_SLIDE_3_1_POLYCOMP_IMAGE from '../../../assets/images/club/stories/switch-level1/switch15/slide-3-1-polycomp.webp';
import SWITCH_15_SLIDE_3_2_POLYCOMP_IMAGE from '../../../assets/images/club/stories/switch-level1/switch15/slide-3-2-polycomp.webp';
import SWITCH_15_SLIDE_3_CC_IMAGE from '../../../assets/images/club/stories/switch-level1/switch15/slide-3-cc.webp';
import SWITCH_15_SLIDE_3_EVAPE_IMAGE from '../../../assets/images/club/stories/switch-level1/switch15/slide-3-evape.webp';
import SWITCH_15_SLIDE_3_POLYCOMP_IMAGE from '../../../assets/images/club/stories/switch-level1/switch15/slide-3-polycomp.webp';
import SWITCH_15_SLIDE_4_IMAGE from '../../../assets/images/club/stories/switch-level1/switch15/slide-4.webp';
import SWITCH_LEVEL_2_1_SLIDE_1_IMAGE from '../../../assets/images/club/stories/switch-level2/switch21/slide-1.webp';
import SWITCH_LEVEL_2_1_SLIDE_2_IMAGE from '../../../assets/images/club/stories/switch-level2/switch21/slide-2.webp';
import SWITCH_LEVEL_2_1_SLIDE_2_1_IMAGE from '../../../assets/images/club/stories/switch-level2/switch21/slide-2-1.webp';
import SWITCH_LEVEL_2_1_SLIDE_3_IMAGE from '../../../assets/images/club/stories/switch-level2/switch21/slide-3.webp';
import SWITCH_LEVEL_2_2_SLIDE_1_IMAGE from '../../../assets/images/club/stories/switch-level2/switch22/slide-1.webp';
import SWITCH_LEVEL_2_2_SLIDE_2_IMAGE from '../../../assets/images/club/stories/switch-level2/switch22/slide-2.webp';
import SWITCH_LEVEL_2_2_SLIDE_3_IMAGE from '../../../assets/images/club/stories/switch-level2/switch22/slide-3.webp';
import SWITCH_LEVEL_2_2_SLIDE_4_IMAGE from '../../../assets/images/club/stories/switch-level2/switch22/slide-4.webp';
import SWITCH_LEVEL_2_3_SLIDE_1_IMAGE from '../../../assets/images/club/stories/switch-level2/switch23/slide-1.webp';
import SWITCH_LEVEL_2_3_SLIDE_2_1_IMAGE from '../../../assets/images/club/stories/switch-level2/switch23/slide-2_1.webp';
import SWITCH_LEVEL_2_3_SLIDE_3_IMAGE from '../../../assets/images/club/stories/switch-level2/switch23/slide-3.webp';
import SWITCH_LEVEL_2_4_SLIDE_1_IMAGE from '../../../assets/images/club/stories/switch-level2/switch24/PROTECTED-slide-1.webp';
import SWITCH_LEVEL_2_4_SLIDE_3_IMAGE from '../../../assets/images/club/stories/switch-level2/switch24/PROTECTED-slide-3.webp';
import SWITCH_LEVEL_2_4_SLIDE_2_IMAGE from '../../../assets/images/club/stories/switch-level2/switch24/slide-2.webp';
import SWITCH_LEVEL_2_4_SLIDE_4_IMAGE_1 from '../../../assets/images/club/stories/switch-level2/switch24/slide-4-1.webp';
import SWITCH_LEVEL_2_4_SLIDE_4_IMAGE_2 from '../../../assets/images/club/stories/switch-level2/switch24/slide-4-2.webp';
import SWITCH_LEVEL_2_4_SLIDE_4_IMAGE_3 from '../../../assets/images/club/stories/switch-level2/switch24/slide-4-3.webp';
import SWITCH_LEVEL_2_4_SLIDE_4_IMAGE_4 from '../../../assets/images/club/stories/switch-level2/switch24/slide-4-4.webp';
import SWITCH_LEVEL_2_5_SLIDE_3_IMAGE from '../../../assets/images/club/stories/switch-level2/switch25/PROTECTED-slide-3.webp';
import SWITCH_LEVEL_2_5_SLIDE_1_IMAGE from '../../../assets/images/club/stories/switch-level2/switch25/slide-1.webp';
import SWITCH_LEVEL_2_5_SLIDE_2_1_IMAGE from '../../../assets/images/club/stories/switch-level2/switch25/slide-2-1.webp';
import SWITCH_LEVEL_2_5_SLIDE_2_2_IMAGE from '../../../assets/images/club/stories/switch-level2/switch25/slide-2-2.webp';
import SWITCH_LEVEL_2_5_SLIDE_2_3_IMAGE from '../../../assets/images/club/stories/switch-level2/switch25/slide-2-3.webp';
import SWITCH_LEVEL_2_5_SLIDE_4_IMAGE from '../../../assets/images/club/stories/switch-level2/switch25/slide-4.webp';
import SWITCH_LEVEL_3_1_SLIDE_1_IMAGE from '../../../assets/images/club/stories/switch-level3/milestone1/slide-1.webp';
import SWITCH_LEVEL_3_1_SLIDE_2_IMAGE from '../../../assets/images/club/stories/switch-level3/milestone1/slide-2.webp';
import SWITCH_LEVEL_3_1_SLIDE_3_1_IMAGE from '../../../assets/images/club/stories/switch-level3/milestone1/slide-3-1.webp';
import SWITCH_LEVEL_3_1_SLIDE_3_REGULAR_IMAGE from '../../../assets/images/club/stories/switch-level3/milestone1/slide-3-regular.webp';
import SWITCH_LEVEL_3_2_SLIDE_1_IMAGE from '../../../assets/images/club/stories/switch-level3/milestone2/PROTECTED-slide-1.webp';
import SWITCH_LEVEL_3_2_SLIDE_5_IMAGE from '../../../assets/images/club/stories/switch-level3/milestone2/PROTECTED-slide-5.webp';
import SWITCH_LEVEL_3_3_SLIDE_2_2_IMAGE from '../../../assets/images/club/stories/switch-level3/milestone3/PROTECTED-slide-2-2.webp';
import SWITCH_LEVEL_3_3_SLIDE_1_IMAGE from '../../../assets/images/club/stories/switch-level3/milestone3/slide-1.webp';
import SWITCH_LEVEL_3_3_SLIDE_2_1_IMAGE from '../../../assets/images/club/stories/switch-level3/milestone3/slide-2-1.webp';
import SWITCH_LEVEL_3_3_SLIDE_2_3_IMAGE from '../../../assets/images/club/stories/switch-level3/milestone3/slide-2-3.webp';
import SWITCH_LEVEL_3_3_SLIDE_3_1_IMAGE from '../../../assets/images/club/stories/switch-level3/milestone3/slide-3-1.webp';
import TOUCH_SCREEN_VIDEO from '../../../assets/videos/club/PROTECTED-flex-touch-screen.mp4';
import TOUCH_SCREEN_THUMBNAIL from '../../../assets/videos/club/PROTECTED-flex-touch-screen-thumbnail.webp';
import QUIZ_STORY_1_VIDEO from '../../../assets/videos/club/PROTECTED-quiz-story-1.mp4';
import QUIZ_STORY_1_THUMBNAIL from '../../../assets/videos/club/PROTECTED-quiz-story-thumbnail-1.webp';
import AUTOSTART_VIDEO from '../../../assets/videos/club/PROTECTED-stories-autostart.mp4';
import AUTOSTART_VIDEO_THUMBNAIL from '../../../assets/videos/club/PROTECTED-stories-autostart-thumbnail.webp';
import FLEX_PUFF_VIDEO from '../../../assets/videos/club/PROTECTED-stories-flex-puff.mp4';
import FLEX_PUFF_THUMBNAIL from '../../../assets/videos/club/PROTECTED-stories-flex-puff-thumbnail.webp';
import HIGHLIGHT_1_VIDEO from '../../../assets/videos/club/PROTECTED-stories-highlights-1.mp4';
import HIGHLIGHT_2_VIDEO from '../../../assets/videos/club/PROTECTED-stories-highlights-2.mp4';
import HIGHLIGHT_1_THUMBNAIL from '../../../assets/videos/club/PROTECTED-stories-highlights-thumbnail-1.webp';
import HIGHLIGHT_2_THUMBNAIL from '../../../assets/videos/club/PROTECTED-stories-highlights-thumbnail-2.webp';
import PAUSE_MODE_VIDEO from '../../../assets/videos/club/PROTECTED-stories-pause-mode.mp4';
import PAUSE_MODE_THUMBNAIL from '../../../assets/videos/club/PROTECTED-stories-pause-mode-thumbnail.webp';
import ConfirmationIcon from '../../../components/Icons/ClubPage/ConfirmationIcon';
import awsRumActionNames from '../../../consts/aws/awsRumActionNames';
import articleTypes from '../../../consts/loyalty/articleTypes';
import badgeLevelTypes from '../../../consts/loyalty/badgeLevelTypes';
import badgeTypes from '../../../consts/loyalty/badgeTypes';
import milestoneTypes from '../../../consts/loyalty/milestoneTypes';
import quizTypes from '../../../consts/loyalty/quizTypes';
import storiesTypes from '../../../consts/loyalty/storiesTypes';
import storyContentTypes from '../../../consts/loyalty/storyContentTypes';
import userSegmentTypes from '../../../consts/loyalty/userSegmentTypes';
import routes from '../../../consts/routes';
import {strCode} from '../../../consts/strCode';
import routerService from '../../../services/router/routerService';
import {openIqosUrl, openUrl} from '../../../services/urlService';
import {showClubPageArticleModal, showClubPageQuizModal, showSocialsModal} from '../../../state/slice/modal';
import {dispatch} from '../../../state/store';
import helpers from '../../../utils/helpers';
import ClubPageMostPopularFlavours from '../components/ClubPageStories/ClubPageMostPopularFlavours';

const CLUB_PAGE_STORIES_CONTENT = {
    [storiesTypes.HIGHLIGHTS]: {
        milestoneType: milestoneTypes.IQOS_CLUB_VIDEO,
        badgeType: badgeTypes.IQOS_CLUB_FIRST_STEPS,
        previewHeaderStrCode: strCode.CLUB_PAGE_STORIES_HIGHLIGHTS_SUBTITLE,
        previewImageSrc: HIGHLIGHT_PREVIEW_IMAGE,
        previewTitleStrCode: strCode.CLUB_PAGE_STORIES_HIGHLIGHTS_PREVIEW_TITLE,
        previewDescriptionStrCode: strCode.CLUB_PAGE_STORIES_HIGHLIGHTS_PREVIEW_DESCRIPTION,
        stories: [
            {
                videoSrc: HIGHLIGHT_1_VIDEO,
                thumbnailSrc: HIGHLIGHT_1_THUMBNAIL,
                titleStrCode: strCode.CLUB_PAGE_STORIES_HIGHLIGHTS_SLIDE_1_TITLE,
                descriptionStrCode: strCode.CLUB_PAGE_STORIES_HIGHLIGHTS_SLIDE_1_DESCRIPTION,
                isOverlayVisible: false,
            },
            {
                videoSrc: HIGHLIGHT_2_VIDEO,
                thumbnailSrc: HIGHLIGHT_2_THUMBNAIL,
                titleStrCode: strCode.CLUB_PAGE_STORIES_HIGHLIGHTS_SLIDE_2_TITLE,
                descriptionStrCode: strCode.CLUB_PAGE_STORIES_HIGHLIGHTS_SLIDE_2_DESCRIPTION,
                isOverlayVisible: false,
            },
            {
                imageSrc: HIGHLIGHT_3_IMAGE,
                titleStrCode: strCode.CLUB_PAGE_STORIES_HIGHLIGHTS_SLIDE_3_TITLE,
                descriptionStrCode: strCode.CLUB_PAGE_STORIES_HIGHLIGHTS_SLIDE_3_DESCRIPTION,
                buttonStrCode: strCode.CLUB_PAGE_STORIES_HIGHLIGHTS_SLIDE_3_BUTTON,
                onButtonClick: (navigate) => {
                    navigate({
                        route: routes.CLUB,
                        milestoneType: milestoneTypes.IQOS_CLUB_VIDEO,
                        timeout: 0,
                    });
                },
                isOverlayVisible: false,
            },
        ],
    },
    [storiesTypes.HIGHLIGHTS_AND_QUIZ]: {
        badgeType: badgeTypes.QUEST_CHAMPION,
        milestoneType: milestoneTypes.QUEST_CHAMPION_QUIZ,
        previewHeaderStrCode: strCode.CLUB_PAGE_STORIES_HIGHLIGHTS_SUBTITLE,
        previewImageSrc: QUIZ_STORY_1_THUMBNAIL,
        previewTitleStrCode: strCode.CLUB_PAGE_STORIES_HIGHLIGHTS_AND_QUIZ_PREVIEW_TITLE,
        previewDescriptionStrCode: strCode.CLUB_PAGE_STORIES_HIGHLIGHTS_AND_QUIZ_PREVIEW_DESCRIPTION,
        isManualFinish: true,
        stories: [
            {
                contentType: storyContentTypes.MEDIA,
                videoSrc: QUIZ_STORY_1_VIDEO,
                thumbnailSrc: QUIZ_STORY_1_THUMBNAIL,
                isFullScreenVideo: true,
                titleStrCode: strCode.CLUB_PAGE_STORIES_HIGHLIGHTS_SLIDE_1_TITLE,
                descriptionStrCode: strCode.CLUB_PAGE_STORIES_HIGHLIGHTS_SLIDE_1_DESCRIPTION,
                subTitleStrCode: strCode.CLUB_PAGE_STORIES_HIGHLIGHTS_SUBTITLE,
                isOverlayVisible: false,
            },
            {
                questionId: 1,
                quizType: quizTypes.STORY_QUIZ,
                contentType: storyContentTypes.QUIZ,
                titleStrCode: strCode.CLUB_PAGE_STORIES_HIGHLIGHTS_QUIZ_TITLE,
                descriptionStrCode: strCode.CLUB_PAGE_STORIES_HIGHLIGHTS_QUIZ_DESCRIPTION,
                options: [
                    {id: '1_1', titleStrCode: strCode.CLUB_PAGE_STORIES_HIGHLIGHTS_QUIZ_ANSWER_1},
                    {id: '1_2', titleStrCode: strCode.CLUB_PAGE_STORIES_HIGHLIGHTS_QUIZ_ANSWER_2},
                    {id: '1_3', titleStrCode: strCode.CLUB_PAGE_STORIES_HIGHLIGHTS_QUIZ_ANSWER_3},
                ],
            },
        ],
    },
    [storiesTypes.LEVIA]: {
        titleStrCode: strCode.CLUB_PAGE_STORIES_LEVIA_TITLE,
        descriptionStrCode: strCode.CLUB_PAGE_STORIES_LEVIA_DESCRIPTION,
        previewImageSrc: LEVIA_PREVIEW_IMAGE,
        previewHeaderStrCode: strCode.CLUB_PAGE_STORIES_LEVIA_SUBTITLE,
        previewTitleStrCode: strCode.CLUB_PAGE_STORIES_LEVIA_PREVIEW_TITLE,
        previewDescriptionStrCode: strCode.CLUB_PAGE_STORIES_LEVIA_PREVIEW_DESCRIPTION,
        isBottomShadowActive: false,
        isLight: true,
        stories: [
            {
                imageSrc: LIVIA_1_IMAGE,
                isImageContain: true,
                titleStrCode: strCode.CLUB_PAGE_STORIES_LEVIA_SLIDE_1_TITLE,
                descriptionStrCode: strCode.CLUB_PAGE_STORIES_LEVIA_SLIDE_1_DESCRIPTION,
                isOverlayVisible: false,
            },
            {
                imageSrc: LIVIA_2_IMAGE,
                isImageContain: true,
                titleStrCode: strCode.CLUB_PAGE_STORIES_LEVIA_SLIDE_2_TITLE,
                descriptionStrCode: strCode.CLUB_PAGE_STORIES_LEVIA_SLIDE_2_DESCRIPTION,
                isOverlayVisible: false,
            },
        ],
    },
    [storiesTypes.HOW_TO_USE_STORIES]: {
        milestoneType: milestoneTypes.SWITCH_11,
        badgeType: badgeTypes.SWITCH_MASTER,
        badgeLevelType: badgeLevelTypes.SWITCH_MASTER_LEVEL_1,
        isManualFinish: true,
        stories: [
            {
                imageSrc: SWITCH_11_SLIDE_1_IMAGE,
                headerStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_11_SLIDE_1_HEADER,
                titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_11_SLIDE_1_BOTTOM_TITLE,
                descriptionStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_11_SLIDE_1_BOTTOM_DESCRIPTION,
                isAlignTop: true,
            },
            {
                contentType: storyContentTypes.FEED,
                headerStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_11_SLIDE_2_HEADER,
                feed: [
                    {
                        imageSrc: SWITCH_11_SLIDE_2_IMAGE,
                        titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_11_SLIDE_2_TOP_TITLE,
                        descriptionStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_11_SLIDE_2_TOP_DESCRIPTION,
                        discoverBtnStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_11_SLIDE_2_BOTTOM_DISCOVER_BTN,
                        isAlignTop: true,
                    },
                    {
                        videoSrc: AUTOSTART_VIDEO,
                        thumbnailSrc: AUTOSTART_VIDEO_THUMBNAIL,
                        titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_11_SLIDE_2_1_BOTTOM_TITLE,
                        descriptionStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_11_SLIDE_2_1_BOTTOM_DESCRIPTION,
                        isFullScreenVideo: true,
                    },
                    {
                        videoSrc: TOUCH_SCREEN_VIDEO,
                        thumbnailSrc: TOUCH_SCREEN_THUMBNAIL,
                        titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_11_SLIDE_2_2_BOTTOM_TITLE,
                        descriptionStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_11_SLIDE_2_2_BOTTOM_DESCRIPTION,
                        isFullScreenVideo: true,
                    },
                    {
                        videoSrc: PAUSE_MODE_VIDEO,
                        thumbnailSrc: PAUSE_MODE_THUMBNAIL,
                        titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_11_SLIDE_2_3_BOTTOM_TITLE,
                        descriptionStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_11_SLIDE_2_3_BOTTOM_DESCRIPTION,
                        isFullScreenVideo: true,
                    },
                    {
                        videoSrc: FLEX_PUFF_VIDEO,
                        thumbnailSrc: FLEX_PUFF_THUMBNAIL,
                        titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_11_SLIDE_2_4_TOP_TITLE,
                        descriptionStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_11_SLIDE_2_4_TOP_DESCRIPTION,
                        isFullScreenVideo: true,
                        isAlignTop: true,
                    },
                    {
                        imageSrc: SWITCH_11_SLIDE_2_5_IMAGE,
                        buttonStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_11_SLIDE_2_5_BTN,
                        descriptionStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_11_SLIDE_2_5_TOP_DESCRIPTION,
                        isAlignCenter: true,
                    },
                ],
            },
            {
                [userSegmentTypes.LOW]: {
                    contentType: storyContentTypes.MEDIA,
                    imageSrc: SWITCH_11_SLIDE_2_LOW_IMAGE,
                    headerStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_11_SLIDE_2_LOW_HEADER,
                    titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_11_SLIDE_2_LOW_TITLE,
                    descriptionStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_11_SLIDE_2_LOW_DESCRIPTION,
                    isAlignTop: true,
                },
            },
            {
                imageSrc: SWITCH_11_SLIDE_3_IMAGE,
                headerStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_11_SLIDE_3_HEADER,
                titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_11_SLIDE_3_TOP_TITLE,
                descriptionStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_11_SLIDE_3_TOP_DESCRIPTION,
                buttonStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_11_SLIDE_3_BTN,
                isAlignTop: true,
                onButtonClick: () => {
                    dispatch(showClubPageQuizModal({quizType: quizTypes.HOW_TO_USE_QUIZ}));
                },
            },
        ],
    },
    [storiesTypes.MANAGE_EXPECTATIONS]: {
        milestoneType: milestoneTypes.SWITCH_12,
        badgeType: badgeTypes.SWITCH_MASTER,
        badgeLevelType: badgeLevelTypes.SWITCH_MASTER_LEVEL_1,
        stories: [
            {
                imageSrc: SWITCH_12_SLIDE_1_IMAGE,
                headerStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_12_SLIDE_1_HEADER,
                titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_12_SLIDE_1_TITLE,
                descriptionStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_12_SLIDE_1_DESCRIPTION,
                isAlignTop: true,
            },
            {
                contentType: storyContentTypes.FEED,
                headerStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_12_SLIDE_2_HEADER,
                feed: [
                    {
                        imageSrc: SWITCH_12_SLIDE_2_IMAGE,
                        titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_12_SLIDE_2_TOP_TITLE,
                        descriptionStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_12_SLIDE_2_TOP_DESCRIPTION,
                        discoverBtnStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_12_SLIDE_2_BOTTOM_DISCOVER_BTN,
                        isAlignTop: true,
                    },
                    {
                        imageSrc: SWITCH_12_SLIDE_2_1_SOCIAL_IMAGE,
                        titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_12_SLIDE_2_1_BOTTOM_TITLE,
                        descriptionStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_12_SLIDE_2_1_BOTTOM_DESCRIPTION,
                    },
                    {
                        imageSrc: SWITCH_12_SLIDE_2_2_SOCIAL_IMAGE,
                        titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_12_SLIDE_2_2_TITLE,
                        descriptionStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_12_SLIDE_2_2_DESCRIPTION,
                        isAlignTop: true,
                    },
                    {
                        imageSrc: SWITCH_12_SLIDE_2_3_SOCIAL_IMAGE,
                        descriptionStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_12_SLIDE_2_3_DESCRIPTION,
                        buttonStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_12_SLIDE_2_3_BTN,
                        isAlignCenter: true,
                    },
                ],
                [userSegmentTypes.TASTE]: {
                    contentType: storyContentTypes.FEED,
                    headerStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_12_SLIDE_2_TASTE_HEADER,
                    feed: [
                        {
                            imageSrc: SWITCH_12_SLIDE_2_IMAGE,
                            titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_12_SLIDE_2_TASTE_TOP_TITLE,
                            descriptionStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_12_SLIDE_2_TASTE_TOP_DESCRIPTION,
                            discoverBtnStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_12_SLIDE_2_TASTE_BOTTOM_DISCOVER_BTN,
                            isAlignTop: true,
                        },
                        {
                            imageSrc: SWITCH_12_SLIDE_2_1_TASTE_IMAGE,
                            titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_12_SLIDE_2_1_TASTE_BOTTOM_TITLE,
                            descriptionStrCode:
                                strCode.CLUB_PAGE_MILESTONE_SWITCH_12_SLIDE_2_1_TASTE_BOTTOM_DESCRIPTION,
                        },
                        {
                            imageSrc: SWITCH_12_SLIDE_2_2_SOCIAL_IMAGE,
                            titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_12_SLIDE_2_2_TITLE,
                            descriptionStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_12_SLIDE_2_2_DESCRIPTION,
                            disclaimerStr: strCode.CLUB_PAGE_MILESTONE_SWITCH_12_SLIDE_2_2_TASTE_DISCLAIMER,
                            buttonStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_12_SLIDE_2_2_TASTE_BTN,
                            isAlignTop: true,
                        },
                    ],
                },
                [userSegmentTypes.AESTHETIC]: {
                    contentType: storyContentTypes.FEED,
                    headerStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_12_SLIDE_2_HEALTH_HEADER,
                    feed: [
                        {
                            imageSrc: SWITCH_12_SLIDE_2_IMAGE,
                            titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_12_SLIDE_2_HEALTH_TOP_TITLE,
                            descriptionStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_12_SLIDE_2_HEALTH_TOP_DESCRIPTION,
                            discoverBtnStrCode:
                                strCode.CLUB_PAGE_MILESTONE_SWITCH_12_SLIDE_2_HEALTH_BOTTOM_DISCOVER_BTN,
                            isAlignTop: true,
                        },
                        {
                            imageSrc: SWITCH_12_SLIDE_2_IMAGE,
                            disclaimerItems: [
                                {
                                    icon: ConfirmationIcon,
                                    itemStr: strCode.CLUB_PAGE_MILESTONE_SWITCH_12_SLIDE_2_1_HEALTH_INFO_ITEM_1,
                                },
                                {
                                    icon: ConfirmationIcon,
                                    itemStr: strCode.CLUB_PAGE_MILESTONE_SWITCH_12_SLIDE_2_1_HEALTH_INFO_ITEM_2,
                                },
                            ],
                            disclaimerStr: strCode.CLUB_PAGE_MILESTONE_SWITCH_12_SLIDE_2_1_HEALTH_INFO_DISCLAIMER,
                            referenceStr: strCode.CLUB_PAGE_MILESTONE_SWITCH_12_SLIDE_2_1_HEALTH_INFO_REFERENCE,
                        },
                        {
                            imageSrc: SWITCH_12_SLIDE_2_2_SOCIAL_IMAGE,
                            titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_12_SLIDE_2_2_TITLE,
                            descriptionStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_12_SLIDE_2_2_DESCRIPTION,
                            disclaimerStr: strCode.CLUB_PAGE_MILESTONE_SWITCH_12_SLIDE_2_2_HEALTH_DISCLAIMER,
                            buttonStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_12_SLIDE_2_2_HEALTH_BTN,
                            isAlignTop: true,
                        },
                    ],
                },
            },
            {
                imageSrc: SWITCH_12_SLIDE_3_IMAGE,
                headerStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_12_SLIDE_3_HEADER,
                titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_12_SLIDE_3_BOTTOM_TITLE,
                descriptionStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_12_SLIDE_3_BOTTOM_DESCRIPTION,
                isAlignTop: true,
            },
            {
                contentType: storyContentTypes.FEED,
                headerStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_12_SLIDE_4_HEADER,
                feed: [
                    {
                        imageSrc: SWITCH_12_SLIDE_4_CC_IMAGE,
                        titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_12_SLIDE_4_TOP_TITLE,
                        descriptionStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_12_SLIDE_4_TOP_DESCRIPTION,
                        discoverBtnStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_12_SLIDE_4_BOTTOM_DISCOVER_BTN,
                        isAlignTop: true,
                    },
                    {
                        imageSrc: SWITCH_12_SLIDE_4_1_IMAGE,
                        titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_12_SLIDE_4_1_TITLE,
                        descriptionStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_12_SLIDE_4_1_DESCRIPTION,
                        buttonStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_12_SLIDE_4_1_BTN,
                        onButtonClick: (navigate) => {
                            navigate({
                                route: routerService.getPersonaliseRoute(),
                                milestoneType: milestoneTypes.SWITCH_12,
                            });
                        },
                        isAlignTop: true,
                    },
                ],
                [userSegmentTypes.EVAPE_DUAL]: {
                    contentType: storyContentTypes.FEED,
                    headerStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_12_SLIDE_4_EVAPE_HEADER,
                    feed: [
                        {
                            imageSrc: SWITCH_12_SLIDE_4_EVAPE_IMAGE,
                            titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_12_SLIDE_4_EVAPE_TOP_TITLE,
                            descriptionStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_12_SLIDE_4_EVAPE_TOP_DESCRIPTION,
                            discoverBtnStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_12_SLIDE_4_BOTTOM_DISCOVER_BTN,
                            isAlignTop: true,
                        },
                        {
                            imageSrc: SWITCH_12_SLIDE_4_1_IMAGE,
                            titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_12_SLIDE_4_1_EVAPE_TITLE,
                            descriptionStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_12_SLIDE_4_1_EVAPE_DESCRIPTION,
                            buttonStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_12_SLIDE_4_1_EVAPE_BTN,
                            onButtonClick: (navigate) => {
                                navigate({
                                    route: routerService.getPersonaliseRoute(),
                                    milestoneType: milestoneTypes.SWITCH_12,
                                });
                            },
                            isAlignTop: true,
                        },
                    ],
                },
                [userSegmentTypes.POLY_HNB]: {
                    contentType: storyContentTypes.FEED,
                    headerStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_12_SLIDE_4_POLYCOMP_HEADER,
                    feed: [
                        {
                            imageSrc: SWITCH_12_SLIDE_4_POLYCOMP_IMAGE,
                            titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_12_SLIDE_4_POLYCOMP_TOP_TITLE,
                            descriptionStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_12_SLIDE_4_POLYCOMP_TOP_DESCRIPTION,
                            discoverBtnStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_12_SLIDE_4_BOTTOM_DISCOVER_BTN,
                            isAlignTop: true,
                        },
                        {
                            imageSrc: SWITCH_12_SLIDE_4_1_IMAGE,
                            titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_12_SLIDE_4_1_POLYCOMP_TITLE,
                            descriptionStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_12_SLIDE_4_1_POLYCOMP_DESCRIPTION,
                            buttonStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_12_SLIDE_4_1_POLYCOMP_BTN,
                            onButtonClick: (navigate) => {
                                navigate({
                                    route: routerService.getPersonaliseRoute(),
                                    milestoneType: milestoneTypes.SWITCH_12,
                                });
                            },
                            isAlignTop: true,
                        },
                    ],
                },
                [userSegmentTypes.COMP_HNB]: {
                    contentType: storyContentTypes.FEED,
                    headerStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_12_SLIDE_4_POLYCOMP_HEADER,
                    feed: [
                        {
                            imageSrc: SWITCH_12_SLIDE_4_POLYCOMP_IMAGE,
                            titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_12_SLIDE_4_POLYCOMP_TOP_TITLE,
                            descriptionStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_12_SLIDE_4_POLYCOMP_TOP_DESCRIPTION,
                            discoverBtnStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_12_SLIDE_4_BOTTOM_DISCOVER_BTN,
                            isAlignTop: true,
                        },
                        {
                            imageSrc: SWITCH_12_SLIDE_4_1_IMAGE,
                            titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_12_SLIDE_4_1_POLYCOMP_TITLE,
                            descriptionStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_12_SLIDE_4_1_POLYCOMP_DESCRIPTION,
                            buttonStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_12_SLIDE_4_1_POLYCOMP_BTN,
                            onButtonClick: (navigate) => {
                                navigate({
                                    route: routerService.getPersonaliseRoute(),
                                    milestoneType: milestoneTypes.SWITCH_12,
                                });
                            },
                            isAlignTop: true,
                        },
                    ],
                },
            },
        ],
    },
    [storiesTypes.TASTE_DISCOVERY]: {
        milestoneType: milestoneTypes.SWITCH_13,
        badgeType: badgeTypes.SWITCH_MASTER,
        badgeLevelType: badgeLevelTypes.SWITCH_MASTER_LEVEL_1,
        isManualFinish: true,
        stories: [
            {
                contentType: storyContentTypes.FEED,
                headerStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_13_CC_HEADER,

                [userSegmentTypes.EVAPE_DUAL]: {
                    headerStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_13_EVAPE_HEADER,
                },
                [userSegmentTypes.COMP_HNB]: {
                    headerStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_13_COMP_HEADER,
                },
                feed: [
                    {
                        imageSrc: SWITCH_13_SLIDE_1_COMP_IMAGE,
                        titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_13_SLIDE_1_CC_BOTTOM_TITLE,
                        descriptionStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_13_SLIDE_1_CC_BOTTOM_DESCRIPTION,
                        discoverBtnStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_13_SLIDE_1_BTN,
                        onButtonClick: () => {
                            dispatch(showClubPageArticleModal({articleType: articleTypes.EXPLORE_TEREA}));
                        },
                        isAlignTop: true,
                        [userSegmentTypes.EVAPE_DUAL]: {
                            imageSrc: SWITCH_13_SLIDE_1_EVAPE_IMAGE,
                            titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_13_SLIDE_1_EVAPE_BOTTOM_TITLE,
                            descriptionStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_13_SLIDE_1_EVAPE_BOTTOM_DESCRIPTION,
                            isAlignTop: true,
                            discoverBtnStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_13_SLIDE_1_EVAPE_DISCOVER_BTN,
                            onButtonClick: () => {
                                dispatch(showClubPageArticleModal({articleType: articleTypes.EXPLORE_LEVIA}));
                            },
                        },
                        [userSegmentTypes.COMP_HNB]: {
                            imageSrc: SWITCH_13_SLIDE_1_COMP_IMAGE,
                            titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_13_SLIDE_1_COMP_BOTTOM_TITLE,
                            descriptionStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_13_SLIDE_1_COMP_BOTTOM_DESCRIPTION,
                            onButtonClick: () => {
                                dispatch(showClubPageArticleModal({articleType: articleTypes.EXPLORE_TEREA}));
                            },
                        },
                    },
                    {
                        articleType: articleTypes.EXPLORE_TEREA,
                        [userSegmentTypes.COMP_HNB]: {
                            articleType: articleTypes.EXPLORE_TEREA,
                        },
                        [userSegmentTypes.EVAPE_DUAL]: {
                            articleType: articleTypes.EXPLORE_LEVIA,
                        },
                    },
                ],
            },
            {
                contentType: storyContentTypes.FEED,
                headerStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_13_SLIDE_3_HEADER,
                feed: [
                    {
                        imageSrc: SWITCH_13_SLIDE_3_IMAGE,
                        titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_13_SLIDE_3_CC_TITLE,
                        descriptionStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_13_SLIDE_3_CC_DESCRIPTION,
                        discoverBtnStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_13_SLIDE_3_DISCOVER_BTN,
                        isAlignTop: true,
                        [userSegmentTypes.EVAPE_DUAL]: {
                            descriptionStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_13_SLIDE_3_EVAPE_DESCRIPTION,
                        },
                        [userSegmentTypes.COMP_HNB]: {
                            descriptionStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_13_SLIDE_3_COMP_DESCRIPTION,
                        },
                    },
                    {
                        imageSrc: SWITCH_LEVEL_STORE_IMAGE,
                        titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_13_SLIDE_3_1_TITLE,
                        descriptionStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_13_SLIDE_3_1_DESCRIPTION,
                    },
                    {
                        imageSrc: SWITCH_LEVEL_STORE_IMAGE,
                        titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_13_SLIDE_3_2_TITLE,
                        descriptionStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_13_SLIDE_3_2_DESCRIPTION,
                        buttonStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_13_SLIDE_3_2_BTN,
                    },
                ],
            },
            {
                headerStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_13_SLIDE_4_CC_HEADER,
                imageSrc: SWITCH_13_SLIDE_4_IMAGE,
                titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_13_SLIDE_4_CC_TITLE,
                descriptionStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_13_SLIDE_4_CC_DESCRIPTION,
                isAlignTop: true,
                buttonStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_13_SLIDE_4_BTN,
                onButtonClick: () => dispatch(showClubPageQuizModal({quizType: quizTypes.TASTE_DISCOVERY_QUIZ})),
                [userSegmentTypes.EVAPE_DUAL]: {
                    headerStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_13_SLIDE_4_EVAPE_HEADER,
                    titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_13_SLIDE_4_EVAPE_TITLE,
                    descriptionStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_13_SLIDE_4_EVAPE_DESCRIPTION,
                },
                [userSegmentTypes.COMP_HNB]: {
                    headerStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_13_SLIDE_4_COMP_HEADER,
                    titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_13_SLIDE_4_COMP_TITLE,
                    descriptionStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_13_SLIDE_4_COMP_DESCRIPTION,
                },
            },
        ],
    },
    [storiesTypes.EXCLUSIVE_USAGE]: {
        milestoneType: milestoneTypes.SWITCH_14,
        badgeType: badgeTypes.SWITCH_MASTER,
        badgeLevelType: badgeLevelTypes.SWITCH_MASTER_LEVEL_1,
        stories: [
            {
                imageSrc: SWITCH_14_SLIDE_1_IMAGE,
                headerStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_14_SLIDE_1_HEADER,
                titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_14_SLIDE_1_TITLE,
                descriptionStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_14_SLIDE_1_DESCRIPTION,
                isAlignTop: true,
            },
            {
                imageSrc: SWITCH_14_SLIDE_2_IMAGE,
                headerStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_14_SLIDE_2_HEADER,
                titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_14_SLIDE_2_HIGH_BOTTOM_TITLE,
                descriptionStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_14_SLIDE_2_HIGH_BOTTOM_DESCRIPTION,
                isAlignTop: true,
                [userSegmentTypes.MID]: {
                    titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_14_SLIDE_2_MID_BOTTOM_TITLE,
                    descriptionStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_14_SLIDE_2_MID_BOTTOM_DESCRIPTION,
                },
                [userSegmentTypes.LOW]: {
                    contentType: storyContentTypes.FEED,
                    feed: [
                        {
                            imageSrc: SWITCH_14_SLIDE_2_IMAGE,
                            titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_14_SLIDE_2_LOW_BOTTOM_TITLE,
                            descriptionStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_14_SLIDE_2_LOW_BOTTOM_DESCRIPTION,
                            isAlignTop: true,
                        },
                        {
                            imageSrc: SWITCH_14_SLIDE_2_1_IMAGE,
                            descriptionStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_14_SLIDE_2_1_LOW_BOTTOM_DESCRIPTION,
                            buttonStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_14_SLIDE_2_1_LOW_BOTTOM_BTN,
                            isAlignCenter: true,
                        },
                    ],
                },
            },
            {
                imageSrc: SWITCH_14_SLIDE_3_IMAGE,
                headerStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_14_SLIDE_3_HEADER,
                titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_14_SLIDE_3_BOTTOM_TITLE,
                descriptionStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_14_SLIDE_3_BOTTOM_DESCRIPTION,
                isAlignTop: true,
            },
            {
                contentType: storyContentTypes.FEED,
                headerStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_14_SLIDE_4_SOCIAL_HEADER,
                feed: [
                    {
                        imageSrc: SWITCH_14_SLIDE_4_SOCIAL_IMAGE,
                        titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_14_SLIDE_4_SOCIAL_TITLE,
                        descriptionStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_14_SLIDE_4_SOCIAL_DESCRIPTION,
                        disclaimerStr: strCode.CLUB_PAGE_MILESTONE_SWITCH_14_SLIDE_4_SOCIAL_DISCLAIMER,
                        discoverBtnStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_14_SLIDE_4_SOCIAL_DISCOVER_BTN,
                        isAlignTop: true,
                    },
                    {
                        imageSrc: SWITCH_14_SLIDE_4_1_SOCIAL_IMAGE,
                        titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_14_SLIDE_4_1_SOCIAL_TITLE,
                        descriptionStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_14_SLIDE_4_1_SOCIAL_DESCRIPTION,
                        isAlignTop: true,
                    },
                    {
                        imageSrc: SWITCH_14_SLIDE_4_2_SOCIAL_IMAGE,
                        descriptionStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_14_SLIDE_4_2_SOCIAL_DESCRIPTION,
                        buttonStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_14_SLIDE_4_2_SOCIAL_BTN,
                        isAlignCenter: true,
                        onButtonClick: (navigate) => {
                            helpers.scrollTop(); // If open stories from welcome page
                            navigate({
                                route: routes.CLUB_WELCOME,
                                milestoneType: milestoneTypes.SWITCH_14,
                            });
                        },
                    },
                ],
                [userSegmentTypes.TASTE]: {
                    contentType: storyContentTypes.FEED,
                    headerStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_14_SLIDE_4_TASTE_HEADER,
                    feed: [
                        {
                            imageSrc: SWITCH_14_SLIDE_4_TASTE_IMAGE,
                            titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_14_SLIDE_4_TASTE_TITLE,
                            descriptionStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_14_SLIDE_4_TASTE_DESCRIPTION,
                            discoverBtnStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_14_SLIDE_4_TASTE_DISCOVER_BTN,
                            isAlignTop: true,
                        },
                        {
                            imageSrc: SWITCH_14_SLIDE_4_1_TASTE_IMAGE,
                            titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_14_SLIDE_4_1_TASTE_TITLE,
                            descriptionStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_14_SLIDE_4_1_TASTE_DESCRIPTION,
                            buttonStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_14_SLIDE_4_1_TASTE_BTN,
                            isAlignTop: true,
                            onButtonClick: () =>
                                openIqosUrl('https://www.iqos.com/cz/cs/objev/terea-prichute.html', true),
                        },
                    ],
                },
                [userSegmentTypes.AESTHETIC]: {
                    contentType: storyContentTypes.FEED,
                    headerStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_14_SLIDE_4_HEALTH_HEADER,
                    feed: [
                        {
                            imageSrc: SWITCH_14_SLIDE_4_HEALTH_IMAGE,
                            titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_14_SLIDE_4_HEALTH_TITLE,
                            descriptionStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_14_SLIDE_4_HEALTH_DESCRIPTION,
                            discoverBtnStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_14_SLIDE_4_HEALTH_DISCOVER_BTN,
                            isAlignTop: true,
                        },
                        {
                            imageSrc: SWITCH_14_SLIDE_4_HEALTH_IMAGE,
                            disclaimerItems: [
                                {
                                    icon: ConfirmationIcon,
                                    itemStr: strCode.CLUB_PAGE_MILESTONE_SWITCH_14_SLIDE_4_1_HEALTH_INFO_ITEM_1,
                                },
                            ],
                            disclaimerStr: strCode.CLUB_PAGE_MILESTONE_SWITCH_14_SLIDE_4_1_HEALTH_INFO_DISCLAIMER,
                            referenceStr: strCode.CLUB_PAGE_MILESTONE_SWITCH_14_SLIDE_4_1_HEALTH_INFO_REFERENCE,
                            buttonStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_14_SLIDE_4_1_HEALTH_BTN,
                            onButtonClick: () =>
                                openIqosUrl('https://www.iqos.com/cz/cs/objev/terea-prichute.html', true),
                        },
                    ],
                },
            },
        ],
    },
    [storiesTypes.SUPERIORITY_CONVENIENCE]: {
        milestoneType: milestoneTypes.SWITCH_15,
        badgeType: badgeTypes.SWITCH_MASTER,
        badgeLevelType: badgeLevelTypes.SWITCH_MASTER_LEVEL_1,
        stories: [
            {
                imageSrc: SWITCH_15_SLIDE_1_IMAGE,
                headerStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_15_SLIDE_1_CC_HEADER,
                titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_15_SLIDE_1_CC_TITLE,
                descriptionStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_15_SLIDE_1_CC_DESCRIPTION,
                isAlignTop: true,
            },
            {
                [userSegmentTypes.CC]: {
                    contentType: storyContentTypes.FEED,
                    headerStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_15_SLIDE_2_CC_HEADER,
                    feed: [
                        {
                            imageSrc: SWITCH_15_SLIDE_2_CC_IMAGE,
                            titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_15_SLIDE_2_CC_TITLE,
                            descriptionStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_15_SLIDE_2_CC_DESCRIPTION,
                            disclaimerStr: strCode.CLUB_PAGE_MILESTONE_SWITCH_15_SLIDE_2_CC_DISCLAIMER,
                            discoverBtnStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_15_SLIDE_2_CC_DISCOVER_BTN,
                            isAlignTop: true,
                        },
                        {
                            imageSrc: SWITCH_15_SLIDE_2_1_CC_IMAGE,
                            disclaimerItems: [
                                {
                                    icon: ConfirmationIcon,
                                    itemStr: strCode.CLUB_PAGE_MILESTONE_SWITCH_15_SLIDE_2_1_CC_INFO_ITEM_1,
                                },
                            ],
                            disclaimerStr: strCode.CLUB_PAGE_MILESTONE_SWITCH_15_SLIDE_2_1_CC_INFO_DISCLAIMER,
                            referenceStr: strCode.CLUB_PAGE_MILESTONE_SWITCH_15_SLIDE_2_1_CC_INFO_REFERENCE,
                            buttonStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_15_SLIDE_2_1_CC_BTN,
                        },
                    ],
                },
            },
            {
                contentType: storyContentTypes.FEED,
                headerStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_15_SLIDE_3_CC_HEADER,
                feed: [
                    {
                        imageSrc: SWITCH_15_SLIDE_3_CC_IMAGE,
                        titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_15_SLIDE_3_CC_TITLE,
                        descriptionStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_15_SLIDE_3_CC_DESCRIPTION,
                        discoverBtnStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_15_SLIDE_3_CC_DISCOVER_BTN,
                        isAlignTop: true,
                    },
                    {
                        imageSrc: SWITCH_15_SLIDE_3_1_CC_IMAGE,
                        titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_15_SLIDE_3_1_CC_TITLE,
                        descriptionStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_15_SLIDE_3_1_CC_DESCRIPTION,
                        discoverBtnStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_15_SLIDE_3_1_DISCOVER_BTN,
                        isAlignTop: true,
                    },
                    {
                        articleType: articleTypes.EXPLORE_DELIA,
                    },
                ],
                [userSegmentTypes.EVAPE_DUAL]: {
                    headerStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_15_SLIDE_3_EVAPE_HEADER,
                    feed: [
                        {
                            imageSrc: SWITCH_15_SLIDE_3_EVAPE_IMAGE,
                            titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_15_SLIDE_3_EVAPE_TITLE,
                            discoverBtnStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_15_SLIDE_3_EVAPE_DISCOVER_BTN,
                            isAlignTop: true,
                        },
                        {
                            imageSrc: SWITCH_15_SLIDE_3_1_EVAPE_IMAGE,
                            titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_15_SLIDE_3_1_EVAPE_TITLE,
                            descriptionStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_15_SLIDE_3_1_EVAPE_DESCRIPTION,
                            discoverBtnStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_15_SLIDE_3_1_DISCOVER_BTN,
                            isAlignTop: true,
                        },
                        {
                            articleType: articleTypes.EXPLORE_TEREA,
                        },
                    ],
                },
                [userSegmentTypes.POLY_HNB]: {
                    headerStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_15_SLIDE_3_POLYCOMP_HEADER,
                    feed: [
                        {
                            imageSrc: SWITCH_15_SLIDE_3_POLYCOMP_IMAGE,
                            titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_15_SLIDE_3_POLYCOMP_TITLE,
                            descriptionStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_15_SLIDE_3_POLYCOMP_DESCRIPTION,
                            discoverBtnStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_15_SLIDE_3_POLYCOMP_DISCOVER_BTN,
                            isAlignTop: true,
                        },
                        {
                            imageSrc: SWITCH_15_SLIDE_3_1_POLYCOMP_IMAGE,
                            titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_15_SLIDE_3_1_POLYCOMP_BOTTOM_TITLE,
                            descriptionStrCode:
                                strCode.CLUB_PAGE_MILESTONE_SWITCH_15_SLIDE_3_1_POLYCOMP_BOTTOM_DESCRIPTION,
                        },
                        {
                            imageSrc: SWITCH_15_SLIDE_3_2_POLYCOMP_IMAGE,
                            titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_15_SLIDE_3_2_POLYCOMP_TITLE,
                            descriptionStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_15_SLIDE_3_2_POLYCOMP_DESCRIPTION,
                            discoverBtnStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_15_SLIDE_3_1_DISCOVER_BTN,
                            isAlignTop: true,
                        },
                        {
                            articleType: articleTypes.EXPLORE_LEVIA,
                        },
                    ],
                },
                [userSegmentTypes.COMP_HNB]: {
                    headerStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_15_SLIDE_3_POLYCOMP_HEADER,
                    feed: [
                        {
                            imageSrc: SWITCH_15_SLIDE_3_POLYCOMP_IMAGE,
                            titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_15_SLIDE_3_POLYCOMP_TITLE,
                            descriptionStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_15_SLIDE_3_POLYCOMP_DESCRIPTION,
                            discoverBtnStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_15_SLIDE_3_POLYCOMP_DISCOVER_BTN,
                            isAlignTop: true,
                        },
                        {
                            imageSrc: SWITCH_15_SLIDE_3_1_POLYCOMP_IMAGE,
                            titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_15_SLIDE_3_1_POLYCOMP_BOTTOM_TITLE,
                            descriptionStrCode:
                                strCode.CLUB_PAGE_MILESTONE_SWITCH_15_SLIDE_3_1_POLYCOMP_BOTTOM_DESCRIPTION,
                        },
                        {
                            imageSrc: SWITCH_15_SLIDE_3_2_POLYCOMP_IMAGE,
                            titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_15_SLIDE_3_2_POLYCOMP_TITLE,
                            descriptionStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_15_SLIDE_3_2_POLYCOMP_DESCRIPTION,
                            discoverBtnStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_15_SLIDE_3_1_DISCOVER_BTN,
                            isAlignTop: true,
                        },
                        {
                            articleType: articleTypes.EXPLORE_LEVIA,
                        },
                    ],
                },
            },
            {
                imageSrc: SWITCH_15_SLIDE_4_IMAGE,
                headerStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_15_SLIDE_4_HEADER,
                titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_15_SLIDE_4_TITLE,
                descriptionStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_15_SLIDE_4_DESCRIPTION,
                buttonStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_15_SLIDE_4_BTN,
                isAlignTop: true,
                onButtonClick: () => openIqosUrl('https://www.iqos.com/cz/cs/objev/kup-delia.html', true),
                [userSegmentTypes.EVAPE_DUAL]: {
                    onButtonClick: () => openIqosUrl('https://www.iqos.com/cz/cs/objev/kup-terea.html', true),
                },
                [userSegmentTypes.COMP_HNB]: {
                    onButtonClick: () =>
                        openIqosUrl('https://www.iqos.com/cz/cs/objev/kup-levia-pro-iqos-iluma.html', true),
                },
                [userSegmentTypes.POLY_HNB]: {
                    onButtonClick: () =>
                        openIqosUrl('https://www.iqos.com/cz/cs/objev/kup-levia-pro-iqos-iluma.html', true),
                },
            },
        ],
    },
    [storiesTypes.FIND_PLEASURE]: {
        milestoneType: milestoneTypes.SWITCH_21,
        badgeType: badgeTypes.SWITCH_MASTER,
        badgeLevelType: badgeLevelTypes.SWITCH_MASTER_LEVEL_2,
        stories: [
            {
                headerStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_21_SLIDE_1_HEADER,
                imageSrc: SWITCH_LEVEL_2_1_SLIDE_1_IMAGE,
                titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_21_SLIDE_1_TITLE,
                descriptionStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_21_SLIDE_1_DESCRIPTION,
                isAlignTop: true,
            },
            {
                contentType: storyContentTypes.FEED,
                headerStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_21_SLIDE_2_HEADER,
                feed: [
                    {
                        imageSrc: SWITCH_LEVEL_2_1_SLIDE_2_IMAGE,
                        titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_21_SLIDE_2_1_TITLE,
                        descriptionStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_21_SLIDE_2_1_DESCRIPTION,
                        isAlignTop: true,
                    },
                    {
                        imageSrc: SWITCH_LEVEL_2_1_SLIDE_2_1_IMAGE,
                        descriptionStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_21_SLIDE_2_2_DESCRIPTION,
                        buttonStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_21_SLIDE_2_2_BTN,
                        isAlignCenter: true,
                    },
                ],
            },
            {
                contentType: storyContentTypes.FEED,
                headerStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_21_SLIDE_3_1_HEADER,
                feed: [
                    {
                        imageSrc: SWITCH_LEVEL_2_1_SLIDE_3_IMAGE,
                        titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_21_SLIDE_3_1_TITLE,
                        descriptionStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_21_SLIDE_3_1_DESCRIPTION,
                        discoverBtnStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_21_SLIDE_3_1_DISCOVER_BTN,
                        isAlignTop: true,
                    },
                    {
                        imageSrc: SWITCH_LEVEL_STORE_IMAGE,
                        titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_21_SLIDE_3_2_TITLE,
                        descriptionStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_21_SLIDE_3_2_DESCRIPTION,
                        buttonStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_21_SLIDE_3_2_BTN,
                        onButtonClick: () => openUrl('https://www.google.com/maps?daddr=50.0893624,14.4294632'),
                    },
                    {
                        imageSrc: SWITCH_LEVEL_STORE_IMAGE,
                        titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_21_SLIDE_3_3_TITLE,
                        descriptionStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_21_SLIDE_3_3_DESCRIPTION,
                        buttonStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_21_SLIDE_3_3_BTN,
                        onButtonClick: () => openUrl('https://www.google.com/maps?daddr=50.0733,14.402262'),
                    },
                ],
                isConsecutive3Days: {
                    contentType: storyContentTypes.MEDIA,
                    headerStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_21_SLIDE_3_EXP_HEADER,
                    imageSrc: SWITCH_LEVEL_2_1_SLIDE_3_IMAGE,
                    titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_21_SLIDE_3_EXP_TITLE,
                    descriptionStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_21_SLIDE_3_EXP_DESCRIPTION,
                    isAlignTop: true,
                },
            },
        ],
    },
    [storiesTypes.COMMUNITY]: {
        milestoneType: milestoneTypes.SWITCH_22,
        badgeType: badgeTypes.SWITCH_MASTER,
        badgeLevelType: badgeLevelTypes.SWITCH_MASTER_LEVEL_2,
        stories: [
            {
                headerStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_22_SLIDE_1_HEADER,
                imageSrc: SWITCH_LEVEL_2_2_SLIDE_1_IMAGE,
                titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_22_SLIDE_1_TITLE,
                descriptionStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_22_SLIDE_1_DESCRIPTION,
                isAlignTop: true,
            },
            {
                headerStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_22_SLIDE_2_HEADER,
                imageSrc: SWITCH_LEVEL_2_2_SLIDE_2_IMAGE,
                titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_22_SLIDE_2_TITLE,
                descriptionStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_22_SLIDE_2_DESCRIPTION,
                isAlignTop: true,
            },
            {
                headerStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_22_SLIDE_3_HEADER,
                imageSrc: SWITCH_LEVEL_2_2_SLIDE_3_IMAGE,
                titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_22_SLIDE_3_TITLE,
                descriptionStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_22_SLIDE_3_DESCRIPTION,
                isAlignTop: true,
            },
            {
                headerStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_22_SLIDE_4_HEADER,
                imageSrc: SWITCH_LEVEL_2_2_SLIDE_4_IMAGE,
                titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_22_SLIDE_4_TITLE,
                descriptionStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_22_SLIDE_4_DESCRIPTION,
                buttonStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_22_SLIDE_4_BTN,
                onButtonClick: () => openIqosUrl('https://www.iqos.com/cz/cs/vase-pribehy.html'),
                buttonRumActionName: awsRumActionNames.STORIES,
                secondaryButtonStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_22_SLIDE_4_SECONDARY_BTN,
                onSecondaryButtonClick: () => dispatch(showSocialsModal()),
                secondaryButtonRumActionName: awsRumActionNames.SOCIALS,
                isAlignTop: true,
            },
        ],
    },
    [storiesTypes.MOTIVATION]: {
        badgeType: badgeTypes.SWITCH_MASTER,
        milestoneType: milestoneTypes.SWITCH_23,
        badgeLevelType: badgeLevelTypes.SWITCH_MASTER_LEVEL_2,
        isManualFinish: true,
        stories: [
            {
                contentType: storyContentTypes.FEED,
                headerStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_23_SLIDE_1_HEADER,
                feed: [
                    {
                        imageSrc: SWITCH_LEVEL_2_3_SLIDE_1_IMAGE,
                        titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_23_SLIDE_1_TITLE,
                        descriptionStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_23_SLIDE_1_DESCRIPTION,
                        discoverBtnStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_23_SLIDE_1_DISCOVER_BTN,
                        isAlignTop: true,
                    },
                    {
                        articleType: articleTypes.BENEFITS,
                    },
                ],
            },
            {
                [userSegmentTypes.MILD]: {
                    contentType: storyContentTypes.FEED,
                    headerStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_23_SLIDE_2_HEADER_1,
                    feed: [
                        {
                            imageSrc: SWITCH_LEVEL_2_3_SLIDE_2_1_IMAGE,
                            titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_23_SLIDE_2_1_TITLE_1,
                            descriptionStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_23_SLIDE_2_1_DESCRIPTION_1,
                            discoverBtnStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_23_SLIDE_2_1_DISCOVER_BTN_1,
                            isAlignTop: true,
                        },
                        {
                            imageSrc: SWITCH_LEVEL_STORE_IMAGE,
                            titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_23_SLIDE_2_2_TITLE_1,
                            descriptionStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_23_SLIDE_2_2_DESCRIPTION_1,
                        },
                        {
                            imageSrc: SWITCH_LEVEL_STORE_IMAGE,
                            titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_23_SLIDE_2_3_TITLE_1,
                            descriptionStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_23_SLIDE_2_3_DESCRIPTION_1,
                            buttonStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_23_SLIDE_2_3_BTN_1,
                        },
                    ],
                },
                [userSegmentTypes.SPRINT]: {
                    contentType: storyContentTypes.FEED,
                    headerStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_23_SLIDE_2_HEADER_1,
                    feed: [
                        {
                            imageSrc: SWITCH_LEVEL_2_3_SLIDE_2_1_IMAGE,
                            titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_23_SLIDE_2_1_TITLE_1,
                            descriptionStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_23_SLIDE_2_1_DESCRIPTION_1,
                            discoverBtnStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_23_SLIDE_2_1_DISCOVER_BTN_1,
                            isAlignTop: true,
                        },
                        {
                            imageSrc: SWITCH_LEVEL_STORE_IMAGE,
                            titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_23_SLIDE_2_2_TITLE_1,
                            descriptionStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_23_SLIDE_2_2_DESCRIPTION_1,
                        },
                        {
                            imageSrc: SWITCH_LEVEL_STORE_IMAGE,
                            titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_23_SLIDE_2_3_TITLE_1,
                            descriptionStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_23_SLIDE_2_3_DESCRIPTION_1,
                            buttonStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_23_SLIDE_2_3_BTN_1,
                        },
                    ],
                },
            },
            {
                headerStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_23_SLIDE_3_HEADER,
                imageSrc: SWITCH_LEVEL_2_3_SLIDE_3_IMAGE,
                titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_23_SLIDE_3_TITLE,
                descriptionStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_23_SLIDE_3_DESCRIPTION,
                buttonStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_23_SLIDE_3_BTN,
                isAlignTop: true,
                onButtonClick: () => dispatch(showClubPageQuizModal({quizType: quizTypes.MOTIVATION_QUIZ})),
            },
        ],
    },
    [storiesTypes.TIPS_AND_TRICKS]: {
        milestoneType: milestoneTypes.SWITCH_24,
        badgeType: badgeTypes.SWITCH_MASTER,
        badgeLevelType: badgeLevelTypes.SWITCH_MASTER_LEVEL_2,
        stories: [
            {
                headerStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_24_SLIDE_1_HEADER,
                imageSrc: SWITCH_LEVEL_2_4_SLIDE_1_IMAGE,
                titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_24_SLIDE_1_TITLE,
                descriptionStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_24_SLIDE_1_DESCRIPTION,
                isAlignTop: true,
            },
            {
                headerStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_24_SLIDE_2_HEADER,
                imageSrc: SWITCH_LEVEL_2_4_SLIDE_2_IMAGE,
                titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_24_SLIDE_2_TITLE,
                descriptionStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_24_SLIDE_2_DESCRIPTION,
                isAlignTop: true,
            },
            {
                headerStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_24_SLIDE_3_HEADER,
                imageSrc: SWITCH_LEVEL_2_4_SLIDE_3_IMAGE,
                titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_24_SLIDE_3_TITLE,
                descriptionStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_24_SLIDE_3_DESCRIPTION,
                isAlignTop: true,
            },
            {
                [userSegmentTypes.SPRINT]: {
                    contentType: storyContentTypes.FEED,
                    headerStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_24_SLIDE_4_SPRINT_HEADER,
                    feed: [
                        {
                            imageSrc: SWITCH_LEVEL_2_4_SLIDE_4_IMAGE_1,
                            titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_24_SLIDE_4_1_SPRINT_TITLE,
                            descriptionStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_24_SLIDE_4_1_SPRINT_DESCRIPTION,
                            discoverBtnStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_24_SLIDE_4_1_SPRINT_DISCOVER_BTN,
                            isAlignTop: true,
                        },
                        {
                            imageSrc: SWITCH_LEVEL_2_4_SLIDE_4_IMAGE_2,
                            titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_24_SLIDE_4_2_SPRINT_TITLE,
                            descriptionStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_24_SLIDE_4_2_SPRINT_DESCRIPTION,
                        },
                        {
                            videoSrc: FLEX_PUFF_VIDEO,
                            thumbnailSrc: FLEX_PUFF_THUMBNAIL,
                            titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_24_SLIDE_4_3_SPRINT_TITLE,
                            descriptionStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_24_SLIDE_4_3_SPRINT_DESCRIPTION,
                            isFullScreenVideo: true,
                            isAlignTop: true,
                        },
                        {
                            imageSrc: SWITCH_LEVEL_2_4_SLIDE_4_IMAGE_4,
                            descriptionStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_24_SLIDE_4_4_SPRINT_DESCRIPTION,
                            buttonStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_24_SLIDE_4_4_SPRINT_BTN,
                            onButtonClick: (navigate) => {
                                navigate({
                                    route: routerService.getPersonaliseRoute(),
                                    milestoneType: milestoneTypes.SWITCH_24,
                                });
                            },
                            isAlignCenter: true,
                        },
                    ],
                },
                [userSegmentTypes.MILD]: {
                    headerStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_24_SLIDE_4_MILD_HEADER,
                    imageSrc: SWITCH_LEVEL_2_4_SLIDE_4_IMAGE_3,
                    titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_24_SLIDE_4_MILD_TITLE,
                    descriptionStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_24_SLIDE_4_MILD_DESCRIPTION,
                    buttonStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_24_SLIDE_4_MILD_BUTTON,
                    onButtonClick: (navigate) => {
                        navigate({
                            route: routerService.getPersonaliseRoute(),
                            milestoneType: milestoneTypes.SWITCH_24,
                        });
                    },
                    isAlignTop: true,
                },
                [userSegmentTypes.REGULAR]: {
                    contentType: storyContentTypes.FEED,
                    headerStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_24_SLIDE_4_REGULAR_HEADER,
                    feed: [
                        {
                            imageSrc: SWITCH_LEVEL_2_4_SLIDE_4_IMAGE_1,
                            titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_24_SLIDE_4_1_REGULAR_TITLE,
                            descriptionStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_24_SLIDE_4_1_REGULAR_DESCRIPTION,
                            discoverBtnStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_24_SLIDE_4_1_REGULAR_DISCOVER_BTN,
                            isAlignTop: true,
                        },
                        {
                            imageSrc: SWITCH_LEVEL_2_4_SLIDE_4_IMAGE_2,
                            titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_24_SLIDE_4_2_REGULAR_TITLE,
                            descriptionStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_24_SLIDE_4_2_REGULAR_DESCRIPTION,
                        },
                        {
                            videoSrc: FLEX_PUFF_VIDEO,
                            thumbnailSrc: FLEX_PUFF_THUMBNAIL,
                            titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_24_SLIDE_4_3_REGULAR_TITLE,
                            descriptionStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_24_SLIDE_4_3_REGULAR_DESCRIPTION,
                            isFullScreenVideo: true,
                            isAlignTop: true,
                        },
                        {
                            imageSrc: SWITCH_LEVEL_2_4_SLIDE_4_IMAGE_4,
                            descriptionStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_24_SLIDE_4_4_REGULAR_DESCRIPTION,
                            buttonStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_24_SLIDE_4_4_REGULAR_BTN,
                            onButtonClick: (navigate) => {
                                navigate({
                                    route: routerService.getPersonaliseRoute(),
                                    milestoneType: milestoneTypes.SWITCH_24,
                                });
                            },
                            isAlignCenter: true,
                        },
                    ],
                },
                [userSegmentTypes.CHILLED]: {
                    contentType: storyContentTypes.FEED,
                    headerStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_24_SLIDE_4_CHILLED_HEADER,
                    feed: [
                        {
                            imageSrc: SWITCH_LEVEL_2_4_SLIDE_4_IMAGE_3,
                            titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_24_SLIDE_4_1_CHILLED_TITLE,
                            descriptionStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_24_SLIDE_4_1_CHILLED_DESCRIPTION,
                            discoverBtnStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_24_SLIDE_4_1_CHILLED_DISCOVER_BTN,
                            isAlignTop: true,
                        },
                        {
                            videoSrc: PAUSE_MODE_VIDEO,
                            thumbnailSrc: PAUSE_MODE_THUMBNAIL,
                            titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_24_SLIDE_4_2_CHILLED_TITLE,
                            descriptionStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_24_SLIDE_4_2_CHILLED_DESCRIPTION,
                            isFullScreenVideo: true,
                            isAlignTop: true,
                        },
                        {
                            imageSrc: SWITCH_LEVEL_2_4_SLIDE_4_IMAGE_4,
                            descriptionStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_24_SLIDE_4_3_CHILLED_DESCRIPTION,
                            buttonStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_24_SLIDE_4_3_CHILLED_BTN,
                            onButtonClick: (navigate) => {
                                navigate({
                                    route: routerService.getPersonaliseRoute(),
                                    milestoneType: milestoneTypes.SWITCH_24,
                                });
                            },
                            isAlignCenter: true,
                        },
                    ],
                },
                [userSegmentTypes.ALLERT]: {
                    contentType: storyContentTypes.FEED,
                    headerStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_24_SLIDE_4_ALERT_HEADER,
                    feed: [
                        {
                            imageSrc: SWITCH_LEVEL_2_4_SLIDE_4_IMAGE_1,
                            titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_24_SLIDE_4_1_ALERT_TITLE,
                            descriptionStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_24_SLIDE_4_1_ALERT_DESCRIPTION,
                            discoverBtnStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_24_SLIDE_4_1_ALERT_DISCOVER_BTN,
                            isAlignTop: true,
                        },
                        {
                            imageSrc: SWITCH_LEVEL_2_4_SLIDE_4_IMAGE_2,
                            titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_24_SLIDE_4_2_ALERT_TITLE,
                            descriptionStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_24_SLIDE_4_2_ALERT_DESCRIPTION,
                        },
                        {
                            videoSrc: FLEX_PUFF_VIDEO,
                            thumbnailSrc: FLEX_PUFF_THUMBNAIL,
                            titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_24_SLIDE_4_3_ALERT_TITLE,
                            descriptionStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_24_SLIDE_4_3_ALERT_DESCRIPTION,
                            isFullScreenVideo: true,
                            isAlignTop: true,
                        },
                        {
                            videoSrc: PAUSE_MODE_VIDEO,
                            thumbnailSrc: PAUSE_MODE_THUMBNAIL,
                            titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_24_SLIDE_4_4_ALERT_TITLE,
                            descriptionStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_24_SLIDE_4_4_ALERT_DESCRIPTION,
                            isFullScreenVideo: true,
                            isAlignTop: true,
                        },
                        {
                            imageSrc: SWITCH_LEVEL_2_4_SLIDE_4_IMAGE_4,
                            descriptionStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_24_SLIDE_4_5_ALERT_DESCRIPTION,
                            buttonStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_24_SLIDE_4_5_ALERT_BTN,
                            onButtonClick: (navigate) => {
                                navigate({
                                    route: routerService.getPersonaliseRoute(),
                                    milestoneType: milestoneTypes.SWITCH_24,
                                });
                            },
                            isAlignCenter: true,
                        },
                    ],
                },
            },
        ],
    },
    [storiesTypes.SATISFACTION]: {
        milestoneType: milestoneTypes.SWITCH_25,
        badgeType: badgeTypes.SWITCH_MASTER,
        badgeLevelType: badgeLevelTypes.SWITCH_MASTER_LEVEL_2,
        stories: [
            {
                headerStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_25_SLIDE_1_HEADER,
                imageSrc: SWITCH_LEVEL_2_5_SLIDE_1_IMAGE,
                titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_25_SLIDE_1_TITLE,
                descriptionStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_25_SLIDE_1_DESCRIPTION,
                isAlignTop: true,
            },
            {
                contentType: storyContentTypes.FEED,
                headerStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_25_SLIDE_2_HEADER,
                feed: [
                    {
                        imageSrc: SWITCH_LEVEL_2_5_SLIDE_2_1_IMAGE,
                        titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_25_SLIDE_2_1_TITLE,
                        descriptionStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_25_SLIDE_2_1_DESCRIPTION,
                        discoverBtnStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_25_SLIDE_2_1_DISCOVER_BTN,
                        isAlignTop: true,
                    },
                    {
                        imageSrc: SWITCH_LEVEL_2_5_SLIDE_2_2_IMAGE,
                        titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_25_SLIDE_2_2_TITLE,
                        descriptionStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_25_SLIDE_2_2_DESCRIPTION,
                    },
                    {
                        imageSrc: SWITCH_LEVEL_2_5_SLIDE_2_3_IMAGE,
                        titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_25_SLIDE_2_3_TITLE,
                        descriptionStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_25_SLIDE_2_3_DESCRIPTION,
                        buttonStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_25_SLIDE_2_3_BTN,
                        isAlignTop: true,
                    },
                ],
            },
            {
                headerStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_25_SLIDE_3_HEADER,
                imageSrc: SWITCH_LEVEL_2_5_SLIDE_3_IMAGE,
                titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_25_SLIDE_3_TITLE,
                descriptionStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_25_SLIDE_3_DESCRIPTION,
                isAlignTop: true,
            },
            {
                [userSegmentTypes.MILD]: {
                    headerStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_25_SLIDE_4_HEADER_1,
                    imageSrc: SWITCH_LEVEL_2_5_SLIDE_4_IMAGE,
                    titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_25_SLIDE_4_TITLE_1,
                    descriptionStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_25_SLIDE_4_DESCRIPTION_1,
                    isAlignTop: true,
                    buttonStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_25_SLIDE_4_BTN_1,
                    onButtonClick: () => openIqosUrl('https://www.iqos.com/cz/cs/objev/terea-prichute.html'),
                },
                [userSegmentTypes.SPRINT]: {
                    headerStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_25_SLIDE_4_HEADER_1,
                    imageSrc: SWITCH_LEVEL_2_5_SLIDE_4_IMAGE,
                    titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_25_SLIDE_4_TITLE_1,
                    descriptionStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_25_SLIDE_4_DESCRIPTION_1,
                    isAlignTop: true,
                    buttonStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_25_SLIDE_4_BTN_1,
                    onButtonClick: () => openIqosUrl('https://www.iqos.com/cz/cs/objev/terea-prichute.html'),
                },
                [userSegmentTypes.REGULAR]: {
                    headerStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_25_SLIDE_4_HEADER_2,
                    imageSrc: SWITCH_LEVEL_2_5_SLIDE_4_IMAGE,
                    titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_25_SLIDE_4_TITLE_2,
                    descriptionStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_25_SLIDE_4_DESCRIPTION_2,
                    isAlignTop: true,
                    buttonStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_25_SLIDE_4_BTN_2,
                    onButtonClick: (navigate) => {
                        navigate({
                            route: routerService.getPersonaliseRoute(),
                            milestoneType: milestoneTypes.SWITCH_25,
                        });
                    },
                },
                [userSegmentTypes.CHILLED]: {
                    headerStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_25_SLIDE_4_HEADER_2,
                    imageSrc: SWITCH_LEVEL_2_5_SLIDE_4_IMAGE,
                    titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_25_SLIDE_4_TITLE_2,
                    descriptionStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_25_SLIDE_4_DESCRIPTION_2,
                    isAlignTop: true,
                    buttonStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_25_SLIDE_4_BTN_2,
                    onButtonClick: (navigate) => {
                        navigate({
                            route: routerService.getPersonaliseRoute(),
                            milestoneType: milestoneTypes.SWITCH_25,
                        });
                    },
                },
                [userSegmentTypes.ALLERT]: {
                    headerStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_25_SLIDE_4_HEADER_2,
                    imageSrc: SWITCH_LEVEL_2_5_SLIDE_4_IMAGE,
                    titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_25_SLIDE_4_TITLE_2,
                    descriptionStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_25_SLIDE_4_DESCRIPTION_2,
                    isAlignTop: true,
                    buttonStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_25_SLIDE_4_BTN_2,
                    onButtonClick: (navigate) => {
                        navigate({
                            route: routerService.getPersonaliseRoute(),
                            milestoneType: milestoneTypes.SWITCH_25,
                        });
                    },
                },
            },
        ],
    },
    [storiesTypes.MOST_POPULAR_FLAVOURS]: {
        milestoneType: milestoneTypes.SWITCH_31,
        badgeType: badgeTypes.SWITCH_MASTER,
        badgeLevelType: badgeLevelTypes.SWITCH_MASTER_LEVEL_3,
        stories: [
            {
                imageSrc: SWITCH_LEVEL_3_1_SLIDE_1_IMAGE,
                headerStrCode: strCode.CLUB_PAGE_STORIES_MOST_POPULAR_FLAVOURS_1_HEADER,
                titleStrCode: strCode.CLUB_PAGE_STORIES_MOST_POPULAR_FLAVOURS_1_TITLE,
                descriptionStrCode: strCode.CLUB_PAGE_STORIES_MOST_POPULAR_FLAVOURS_1_DESCRIPTION,
                isAlignTop: true,
            },
            {
                imageSrc: SWITCH_LEVEL_3_1_SLIDE_2_IMAGE,
                headerStrCode: strCode.CLUB_PAGE_STORIES_MOST_POPULAR_FLAVOURS_2_HEADER,
                titleStrCode: strCode.CLUB_PAGE_STORIES_MOST_POPULAR_FLAVOURS_2_TITLE,
                descriptionStrCode: strCode.CLUB_PAGE_STORIES_MOST_POPULAR_FLAVOURS_2_DESCRIPTION,
                component: ClubPageMostPopularFlavours,
                isAlignTop: true,
                disableAutoSwipe: true,
                disableSlideNext: true,
            },
            {
                imageSrc: SWITCH_LEVEL_3_1_SLIDE_3_REGULAR_IMAGE,
                headerStrCode: strCode.CLUB_PAGE_STORIES_MOST_POPULAR_FLAVOURS_REGULAR_3_HEADER,
                titleStrCode: strCode.CLUB_PAGE_STORIES_MOST_POPULAR_FLAVOURS_REGULAR_3_TITLE,
                descriptionStrCode: strCode.CLUB_PAGE_STORIES_MOST_POPULAR_FLAVOURS_REGULAR_3_DESCRIPTION,
                buttonStrCode: strCode.CLUB_PAGE_STORIES_MOST_POPULAR_FLAVOURS_REGULAR_3_BTN,
                onButtonClick: () => openIqosUrl('https://www.iqos.com/cz/cs/objev/kup-terea.html'),
                isAlignTop: true,
                [userSegmentTypes.SPRINT]: {
                    contentType: storyContentTypes.FEED,
                    headerStrCode: strCode.CLUB_PAGE_STORIES_MOST_POPULAR_FLAVOURS_3_HEADER,
                    feed: [
                        {
                            imageSrc: SWITCH_LEVEL_3_1_SLIDE_3_1_IMAGE,
                            titleStrCode: strCode.CLUB_PAGE_STORIES_MOST_POPULAR_FLAVOURS_3_TITLE,
                            descriptionStrCode: strCode.CLUB_PAGE_STORIES_MOST_POPULAR_FLAVOUR_3_DESCRIPTION,
                            discoverBtnStrCode: strCode.CLUB_PAGE_STORIES_MOST_POPULAR_FLAVOURS_REGULAR_3_DISCOVER_BTN,
                            isAlignTop: true,
                        },
                        {
                            imageSrc: SWITCH_LEVEL_STORE_IMAGE,
                            titleStrCode: strCode.CLUB_PAGE_STORIES_MOST_POPULAR_FLAVOURS_3_1_HEADER,
                            descriptionStrCode: strCode.CLUB_PAGE_STORIES_MOST_POPULAR_FLAVOURS_3_1_DESCRIPTION,
                            buttonStrCode: strCode.CLUB_PAGE_STORIES_MOST_POPULAR_FLAVOURS_3_1_BTN,
                            onButtonClick: () => openUrl('https://www.google.com/maps?daddr=50.0893624,14.4294632'),
                        },
                        {
                            imageSrc: SWITCH_LEVEL_STORE_IMAGE,
                            titleStrCode: strCode.CLUB_PAGE_STORIES_MOST_POPULAR_FLAVOURS_3_2_HEADER,
                            descriptionStrCode: strCode.CLUB_PAGE_STORIES_MOST_POPULAR_FLAVOURS_3_2_DESCRIPTION,
                            buttonStrCode: strCode.CLUB_PAGE_STORIES_MOST_POPULAR_FLAVOURS_3_2_BTN,
                            onButtonClick: () => openUrl('https://www.google.com/maps?daddr=50.0733,14.402262'),
                        },
                    ],
                },
                [userSegmentTypes.MILD]: {
                    contentType: storyContentTypes.FEED,
                    headerStrCode: strCode.CLUB_PAGE_STORIES_MOST_POPULAR_FLAVOURS_3_HEADER,
                    feed: [
                        {
                            imageSrc: SWITCH_LEVEL_3_1_SLIDE_3_1_IMAGE,
                            titleStrCode: strCode.CLUB_PAGE_STORIES_MOST_POPULAR_FLAVOURS_3_TITLE,
                            descriptionStrCode: strCode.CLUB_PAGE_STORIES_MOST_POPULAR_FLAVOUR_3_DESCRIPTION,
                            discoverBtnStrCode: strCode.CLUB_PAGE_STORIES_MOST_POPULAR_FLAVOURS_REGULAR_3_DISCOVER_BTN,
                            isAlignTop: true,
                        },
                        {
                            imageSrc: SWITCH_LEVEL_STORE_IMAGE,
                            titleStrCode: strCode.CLUB_PAGE_STORIES_MOST_POPULAR_FLAVOURS_3_1_HEADER,
                            descriptionStrCode: strCode.CLUB_PAGE_STORIES_MOST_POPULAR_FLAVOURS_3_1_DESCRIPTION,
                            buttonStrCode: strCode.CLUB_PAGE_STORIES_MOST_POPULAR_FLAVOURS_3_1_BTN,
                            onButtonClick: () => openUrl('https://www.google.com/maps?daddr=50.0893624,14.4294632'),
                        },
                        {
                            imageSrc: SWITCH_LEVEL_STORE_IMAGE,
                            titleStrCode: strCode.CLUB_PAGE_STORIES_MOST_POPULAR_FLAVOURS_3_2_HEADER,
                            descriptionStrCode: strCode.CLUB_PAGE_STORIES_MOST_POPULAR_FLAVOURS_3_2_DESCRIPTION,
                            buttonStrCode: strCode.CLUB_PAGE_STORIES_MOST_POPULAR_FLAVOURS_3_2_BTN,
                            onButtonClick: () => openUrl('https://www.google.com/maps?daddr=50.0733,14.402262'),
                        },
                    ],
                },
                [userSegmentTypes.CHILLED]: {
                    contentType: storyContentTypes.FEED,
                    headerStrCode: strCode.CLUB_PAGE_STORIES_MOST_POPULAR_FLAVOURS_3_HEADER,
                    feed: [
                        {
                            imageSrc: SWITCH_LEVEL_3_1_SLIDE_3_1_IMAGE,
                            titleStrCode: strCode.CLUB_PAGE_STORIES_MOST_POPULAR_FLAVOURS_3_TITLE,
                            descriptionStrCode: strCode.CLUB_PAGE_STORIES_MOST_POPULAR_FLAVOUR_3_DESCRIPTION,
                            discoverBtnStrCode: strCode.CLUB_PAGE_STORIES_MOST_POPULAR_FLAVOURS_REGULAR_3_DISCOVER_BTN,
                            isAlignTop: true,
                        },
                        {
                            imageSrc: SWITCH_LEVEL_STORE_IMAGE,
                            titleStrCode: strCode.CLUB_PAGE_STORIES_MOST_POPULAR_FLAVOURS_3_1_HEADER,
                            descriptionStrCode: strCode.CLUB_PAGE_STORIES_MOST_POPULAR_FLAVOURS_3_1_DESCRIPTION,
                            buttonStrCode: strCode.CLUB_PAGE_STORIES_MOST_POPULAR_FLAVOURS_3_1_BTN,
                            onButtonClick: () => openUrl('https://www.google.com/maps?daddr=50.0893624,14.4294632'),
                        },
                        {
                            imageSrc: SWITCH_LEVEL_STORE_IMAGE,
                            titleStrCode: strCode.CLUB_PAGE_STORIES_MOST_POPULAR_FLAVOURS_3_2_HEADER,
                            descriptionStrCode: strCode.CLUB_PAGE_STORIES_MOST_POPULAR_FLAVOURS_3_2_DESCRIPTION,
                            buttonStrCode: strCode.CLUB_PAGE_STORIES_MOST_POPULAR_FLAVOURS_3_2_BTN,
                            onButtonClick: () => openUrl('https://www.google.com/maps?daddr=50.0733,14.402262'),
                        },
                    ],
                },
                [userSegmentTypes.ALLERT]: {
                    contentType: storyContentTypes.FEED,
                    headerStrCode: strCode.CLUB_PAGE_STORIES_MOST_POPULAR_FLAVOURS_3_HEADER,
                    feed: [
                        {
                            imageSrc: SWITCH_LEVEL_3_1_SLIDE_3_1_IMAGE,
                            titleStrCode: strCode.CLUB_PAGE_STORIES_MOST_POPULAR_FLAVOURS_3_TITLE,
                            descriptionStrCode: strCode.CLUB_PAGE_STORIES_MOST_POPULAR_FLAVOUR_3_DESCRIPTION,
                            discoverBtnStrCode: strCode.CLUB_PAGE_STORIES_MOST_POPULAR_FLAVOURS_REGULAR_3_DISCOVER_BTN,
                            isAlignTop: true,
                        },
                        {
                            imageSrc: SWITCH_LEVEL_STORE_IMAGE,
                            titleStrCode: strCode.CLUB_PAGE_STORIES_MOST_POPULAR_FLAVOURS_3_1_HEADER,
                            descriptionStrCode: strCode.CLUB_PAGE_STORIES_MOST_POPULAR_FLAVOURS_3_1_DESCRIPTION,
                            buttonStrCode: strCode.CLUB_PAGE_STORIES_MOST_POPULAR_FLAVOURS_3_1_BTN,
                            onButtonClick: () => openUrl('https://www.google.com/maps?daddr=50.0893624,14.4294632'),
                        },
                        {
                            imageSrc: SWITCH_LEVEL_STORE_IMAGE,
                            titleStrCode: strCode.CLUB_PAGE_STORIES_MOST_POPULAR_FLAVOURS_3_2_HEADER,
                            descriptionStrCode: strCode.CLUB_PAGE_STORIES_MOST_POPULAR_FLAVOURS_3_2_DESCRIPTION,
                            buttonStrCode: strCode.CLUB_PAGE_STORIES_MOST_POPULAR_FLAVOURS_3_2_BTN,
                            onButtonClick: () => openUrl('https://www.google.com/maps?daddr=50.0733,14.402262'),
                        },
                    ],
                },
            },
        ],
    },
    [storiesTypes.ADVANCED_FEATURES]: {
        milestoneType: milestoneTypes.SWITCH_32,
        badgeType: badgeTypes.SWITCH_MASTER,
        badgeLevelType: badgeLevelTypes.SWITCH_MASTER_LEVEL_3,
        stories: [
            {
                headerStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_32_SLIDE_1_HEADER,
                imageSrc: SWITCH_LEVEL_3_2_SLIDE_1_IMAGE,
                titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_32_SLIDE_1_TITLE,
                descriptionStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_32_SLIDE_1_DESCRIPTION,
                isAlignTop: true,
            },
            {
                headerStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_32_SLIDE_2_HEADER,
                videoSrc: TOUCH_SCREEN_VIDEO,
                thumbnailSrc: TOUCH_SCREEN_THUMBNAIL,
                titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_32_SLIDE_2_TITLE,
                descriptionStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_32_SLIDE_2_DESCRIPTION,
                isAlignTop: true,
                isFullScreenVideo: true,
            },
            {
                contentType: storyContentTypes.FEED,
                headerStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_32_SLIDE_3_HEADER,
                feed: [
                    {
                        videoSrc: PAUSE_MODE_VIDEO,
                        thumbnailSrc: TOUCH_SCREEN_THUMBNAIL,
                        titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_32_SLIDE_3_TITLE,
                        descriptionStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_32_SLIDE_3_DESCRIPTION,
                        isAlignTop: true,
                        isFullScreenVideo: true,
                    },
                    {
                        imageSrc: SWITCH_LEVEL_2_4_SLIDE_4_IMAGE_4,
                        descriptionStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_32_SLIDE_3_2_DESCRIPTION,
                        buttonStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_32_SLIDE_3_2_BTN,
                        isAlignCenter: true,
                    },
                ],
            },
            {
                videoSrc: FLEX_PUFF_VIDEO,
                thumbnailSrc: FLEX_PUFF_THUMBNAIL,
                headerStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_32_SLIDE_4_HEADER,
                titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_32_SLIDE_4_TITLE,
                descriptionStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_32_SLIDE_4_DESCRIPTION,
                isAlignTop: true,
                isFullScreenVideo: true,
            },
            {
                headerStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_32_SLIDE_5_HEADER,
                imageSrc: SWITCH_LEVEL_3_2_SLIDE_5_IMAGE,
                titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_32_SLIDE_5_TITLE,
                descriptionStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_32_SLIDE_5_DESCRIPTION,
                buttonStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_32_SLIDE_5_BUTTON,
                buttonRumActionName: awsRumActionNames.PERSONALISE,
                onButtonClick: (navigate) => {
                    navigate({
                        route: routes.NOTIFICATIONS,
                        milestoneType: milestoneTypes.SWITCH_32,
                    });
                },
                isAlignTop: true,
            },
        ],
    },
    [storiesTypes.SERVICES_AND_PRIVILEGES]: {
        milestoneType: milestoneTypes.SWITCH_33,
        badgeType: badgeTypes.SWITCH_MASTER,
        badgeLevelType: badgeLevelTypes.SWITCH_MASTER_LEVEL_3,
        stories: [
            {
                headerStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_33_SLIDE_1_HEADER,
                imageSrc: SWITCH_LEVEL_3_3_SLIDE_1_IMAGE,
                titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_33_SLIDE_1_TITLE,
                descriptionStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_33_SLIDE_1_DESCRIPTION,
                isAlignTop: true,
            },
            {
                contentType: storyContentTypes.FEED,
                headerStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_33_SLIDE_3_HEADER,
                feed: [
                    {
                        imageSrc: SWITCH_LEVEL_3_3_SLIDE_3_1_IMAGE,
                        titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_33_SLIDE_3_1_TITLE,
                        descriptionStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_33_SLIDE_3_1_DESCRIPTION,
                        discoverBtnStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_33_SLIDE_3_1_DISCOVER_BTN,
                        isAlignTop: true,
                    },
                    {
                        imageSrc: SWITCH_LEVEL_STORE_IMAGE,
                        titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_33_SLIDE_3_2_TITLE,
                        descriptionStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_33_SLIDE_3_2_DESCRIPTION,
                    },
                    {
                        imageSrc: SWITCH_LEVEL_STORE_IMAGE,
                        titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_33_SLIDE_3_3_TITLE,
                        descriptionStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_33_SLIDE_3_3_DESCRIPTION,
                        buttonStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_33_SLIDE_3_3_BUTTON,
                    },
                ],
            },
            {
                contentType: storyContentTypes.FEED,
                headerStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_33_SLIDE_2_HEADER,
                feed: [
                    {
                        imageSrc: SWITCH_LEVEL_3_3_SLIDE_2_1_IMAGE,
                        titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_33_SLIDE_2_1_TITLE,
                        descriptionStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_33_SLIDE_2_1_DESCRIPTION,
                        discoverBtnStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_33_SLIDE_2_1_DISCOVER_BTN,
                        isAlignTop: true,
                    },
                    {
                        imageSrc: SWITCH_LEVEL_3_3_SLIDE_2_2_IMAGE,
                        titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_33_SLIDE_2_2_TITLE,
                        descriptionStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_33_SLIDE_2_2_DESCRIPTION,
                    },
                    {
                        imageSrc: SWITCH_LEVEL_3_3_SLIDE_2_3_IMAGE,
                        titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_33_SLIDE_2_3_TITLE,
                        descriptionStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_33_SLIDE_2_3_DESCRIPTION,
                        buttonStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_33_SLIDE_2_3_BTN,
                        buttonRumActionName: awsRumActionNames.VIEW_INSIGHTS,
                        onButtonClick: (navigate) => {
                            navigate({
                                route: routerService.getInsightRoute(),
                                milestoneType: milestoneTypes.SWITCH_33,
                            });
                        },
                        isAlignTop: true,
                    },
                ],
            },
        ],
    },
};

export default CLUB_PAGE_STORIES_CONTENT;
